import React from 'react'

import {
  Button,
  Modal,
  ModalInjectedProps,
  useModalContext,
} from '@sketch/components'
import {
  ContinueWithApple,
  getSocialProviderFromToken,
} from '@sketch/modules-common'

import AreYouSureModal from '../AreYouSureModal'
import { ContinueWithGoogle } from '@sketch/modules-common/src/components/SocialSignIn/ContinueWithGoogle'
import { ErrorHandler } from '@sketch/tracing'
import styled from 'styled-components'

const CancelButton = styled(Button)`
  max-width: 70px;
`

const StyledAppleButton = styled(ContinueWithApple)`
  padding: 10px 12px;
`

const StyledGoogleButton = styled(ContinueWithGoogle)`
  padding: 10px 12px;
`

interface SocialDeleteAccountModalProps extends ModalInjectedProps {}

const SocialDeleteAccountModal = ({
  hideModal,
}: SocialDeleteAccountModalProps) => {
  const { showModal } = useModalContext()
  const provider = getSocialProviderFromToken()

  /**
   *  This modal only renders if the user only has Social providers as a sign-in method
   *  The BE bakes the provider in the JWT and it should always be present
   * */
  if (!provider) {
    ErrorHandler.shouldNeverHappen(
      'No social provider found for social only sign-in - Delete Account modal'
    )

    return null
  }

  const handleSocialSignIn = () => {
    showModal(AreYouSureModal, {
      provider,
    })
  }

  const buttonByProvider = {
    APPLE: <StyledAppleButton onClick={handleSocialSignIn} />,
    GOOGLE: <StyledGoogleButton onClick={handleSocialSignIn} />,
  }

  return (
    <Modal title="Delete Your Account?" onCancel={hideModal}>
      <Modal.Body>
        <p>
          Confirm your login credentials to permanently delete your Sketch
          account. This cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton variant="secondary" onClick={hideModal}>
          Cancel
        </CancelButton>
        {buttonByProvider[provider]}
      </Modal.Footer>
    </Modal>
  )
}

export default SocialDeleteAccountModal
